import React from "react";
import { getProductMeter } from "./actions";
import { Table, FormBuilder, Form } from "@redriver/cinnamon";
import { numericFormatter } from "components/displays/DisplayHelper";
import { FormattedNumericInput } from "features/../../../shared/components/forms";

const AddManualReading = () => {
  return (
    <div className="meter-reading-form center">
      <FormBuilder
        loadAction={getProductMeter}
        renderForm={(formProps) => (
          <Form {...formProps}>
            <Form.ArrayTable
              field="items"
              arrayKey="id"
              propagateUpdates="always"
            >
              <Table.Column field="unit" title="UNIT" width="12%" />
              <Table.Column field="meterCode" title="Meter Code" width="22%" />
              <Table.Column
                render={(item) =>
                  numericFormatter(item.currentMeterReading, "-", 0)
                }
                title="Current Meter Reading"
                width="22%"
              />
              <Table.Column
                render={(item) =>
                  item.meterCode != "Total" ? (
                    <FormattedNumericInput field="manualMeterReading" />
                  ) : (
                    numericFormatter(item.manualMeterReading, "-", 0)
                  )
                }
                title="Manual Meter Reading"
                width="22%"
              />
              <Table.Column
                render={(item) => numericFormatter(item.newMeterUsage, "-", 0)}
                title="NEW Meter Usage"
                width="22%"
              />
            </Form.ArrayTable>
            <Form.TextArea className="flex" field="notes" label="Notes" />
          </Form>
        )}
      ></FormBuilder>
    </div>
  );
};

export default AddManualReading;
